export default __webpack_public_path__ + "static/media/xs-logo-refeicao.de9dae42.svg";